module.exports = __webpack_public_path__ + "media/images/plan-1944441e1addb84120668bcc148b5a81.png";